import { render, staticRenderFns } from "./AccountConfigSso.vue?vue&type=template&id=2844971f"
import script from "./AccountConfigSso.vue?vue&type=script&lang=js"
export * from "./AccountConfigSso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports